
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppRoutes } from './routes/AppRoutes';
import { ToastProvider } from './components/ToastProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ScrollToTop from './components/common/ScrollToTop';
import { PageViewTracker } from './components/analytics/PageViewTracker';
import CookieBanner from './components/CookieBanner';
import NotFoundRedirect from './components/common/NotFoundRedirect';
import { setupPerformanceMonitoring } from './utils/performanceMonitoring';
import { AuthProvider } from './hooks/useAuth';
import './App.css';

// Create a client for React Query with enhanced settings
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
    },
  },
});

function App() {
  // Setup performance monitoring
  React.useEffect(() => {
    setupPerformanceMonitoring();
  }, []);

  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ToastProvider>
            <Router>
              <ScrollToTop />
              <PageViewTracker />
              <NotFoundRedirect />
              <AppRoutes />
              <CookieBanner />
            </Router>
          </ToastProvider>
        </AuthProvider>
      </QueryClientProvider>
    </React.StrictMode>
  );
}

export default App;
